/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import TabSignInData from './tabSignInData';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	grid: {
		justifyContent: 'center',
	},
	box: {
		width: '90%',
		maxWidth: 650,
	},
	contentBox: {
		display: 'flex',
		justifyContent: 'center',
		padding: theme.spacing(3),
	}
}));

export default function Content(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Grid container className={classes.grid}>
				<Box boxShadow={4} className={classes.box}>
					<Box className={classes.contentBox}>
							<TabSignInData
								reloadUserData={props.reloadUserData}
								mode={props.mode}
								redirectUri={props.redirectUri}
								clientState={props.clientState}
								clientId={props.clientId}
							/>
						</Box>
				</Box>
			</Grid>
		</div >
	);
}
